import { CommonModule, NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';

import { MessageService } from 'src/services/message.service';

@Component({
  standalone: true,
  selector: 'app-edit-integration',
  templateUrl: './integration-output-modal.html',
  styleUrls: ['./integration-output-modal.css'],
  imports: [CommonModule, IonicModule, FormsModule, NgClass],
})
export class IntegrationOutputModalComponent implements OnInit {
  integration: any;
  integrationOutput = {};

  constructor(
    private msgSrvc: MessageService,
    private modalCtrl: ModalController,
  ) {}

  ngOnInit(): void {
    return;
  }

  onDismissIntegrationOutputModal() {
    this.modalCtrl.dismiss();
  }

  copyIntegrationOutputFieldToClipboard(i: number) {
    navigator.clipboard
      .writeText(this.integrationOutput[i].value)
      .then(() => {
        this.msgSrvc.show('Copied!');
      })
      .catch(() => {
        // Unable to copy
      });
  }
}
